import { createSlice } from '@reduxjs/toolkit';

const headerSummarySlice = createSlice({
  name: 'headerSummary',
  initialState: {
    showSummary: false,
    summaryData: []
  },
  reducers: {
    setShowSummaryAction: (state, action) => {
      state.showSummary = action.payload
    },
    setSummaryDataAction: (state, action) => {
      state.summaryData = action.payload
    }
  }
});

export const { setShowSummaryAction, setSummaryDataAction } = headerSummarySlice.actions;
export default headerSummarySlice.reducer;

export const getShowSummarySelector = (state) => state.headerSummary.showSummary;
export const getSummaryDataSelector = (state) => state.headerSummary.summaryData;

